export enum CurtainOperationType {
	Location,
	Zone,
	Device
}